import '../../../components/DataTable/CustomPaginationComponent.scss'
import React from 'react'
import styled from 'styled-components'

interface RunsPagerProps {
  page: number
  totalPages: number
  onPageChange: (page: number) => void
}

const CurrentPage = styled.div`
  display: flex;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0.25rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  color: #fff;
  border: 1px solid var(--gray-color-gray-900, #212529);
  background: var(--gray-color-gray-900, #212529);
`

export const RunsPager: React.FC<RunsPagerProps> = ({ page, totalPages, onPageChange }) => {
  if (totalPages <= 1) {
    return null
  }
  const atStart = page <= 0
  const atEnd = page >= totalPages - 1
  return (
    <div className='d-flex gap-1 align-items-center'>
      <button className='pagination-button' aria-label='First page' disabled={atStart} onClick={() => onPageChange(0)}>
        <i className='bi bi-chevron-bar-left' />
      </button>
      <button className='pagination-button' aria-label='Previous page' disabled={atStart} onClick={() => onPageChange(page - 1)}>
        <i className='bi bi-chevron-left' />
      </button>
      <CurrentPage className='button-small'>{page + 1}</CurrentPage>
      <button className='pagination-button' aria-label='Next page' disabled={atEnd} onClick={() => onPageChange(page + 1)}>
        <i className='bi bi-chevron-right' />
      </button>
      <button className='pagination-button' aria-label='Last page' disabled={atEnd} onClick={() => onPageChange(totalPages - 1)}>
        <i className='bi bi-chevron-bar-right' />
      </button>
    </div>
  )
}
